import React, {
  createContext,
  Dispatch,
  ReactNode,
  useContext,
  useReducer,
} from "react";
import {
  initialSyncFlowState,
  PathPickSyncFlowAction,
  PathPickSyncFlowState,
  syncFlowReducer,
} from "@/features/pathpick/features/basket/contexts/syncFlowReducer";

// 연동/파일 신청 플로우 상태 — 담은 상품 페이지 서브트리에만 존재한다(언마운트되면 함께 사라진다).
//
// state와 dispatch를 나눠 제공하는 이유: 트리거(패널 버튼·플로팅 바)는 dispatch만 쓰므로
// 단계가 바뀌어도 리렌더되지 않는다. 단계 변경으로 깨어나는 건 모달을 렌더하는 곳뿐이다.
const SyncFlowStateContext = createContext<PathPickSyncFlowState | null>(null);
const SyncFlowDispatchContext =
  createContext<Dispatch<PathPickSyncFlowAction> | null>(null);

export function PathPickBasketSyncFlowProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [state, dispatch] = useReducer(syncFlowReducer, initialSyncFlowState);

  return (
    <SyncFlowDispatchContext.Provider value={dispatch}>
      <SyncFlowStateContext.Provider value={state}>
        {children}
      </SyncFlowStateContext.Provider>
    </SyncFlowDispatchContext.Provider>
  );
}

export const usePathPickBasketSyncFlowState = () => {
  const state = useContext(SyncFlowStateContext);
  if (!state) {
    throw new Error(
      "usePathPickBasketSyncFlowState는 PathPickBasketSyncFlowProvider 하위에서만 사용할 수 있다."
    );
  }
  return state;
};

export const usePathPickBasketSyncFlowDispatch = () => {
  const dispatch = useContext(SyncFlowDispatchContext);
  if (!dispatch) {
    throw new Error(
      "usePathPickBasketSyncFlowDispatch는 PathPickBasketSyncFlowProvider 하위에서만 사용할 수 있다."
    );
  }
  return dispatch;
};
